<template>
  <div>
    <component :loaded="loaded" :is="entityClass" />
  </div>
</template>

<script>
import { useCoreStore } from '@/stores/core.js'

export default {
  name: 'AbstractEntity',
  props: {
    loaded: {
      type: Boolean,
      required: false
    }
  },
  components: {
    Laboratory: () => import('@/components/admin/entity/Laboratory.vue'),
    Entity: () => import('@/components/admin/entity/Entity.vue'),
    Campus: () => import('@/components/admin/entity/Campus.vue')
  },
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  computed: {
    entityClass: function () {
      return this.coreStore.entityClass
    }
  }
}
</script>
